import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import AppMessage from '../components/AppMessage';
import { onClose } from '../actions';

const mapStateToProps = ({ appMessage }) => ({
  appMessage,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  onClose,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AppMessage);
